import { useEffect } from "react"

export default function ErrorComponent({ error }) {
    console.error("Okta auth error:", error);
    console.log("ErrorComponent")
    useEffect(() => {
        window.history.back();
    }, [])
    return (<div></div>)
}